module.exports = ".list-item {\n  border-radius: 5px;\n  width: 200px;\n  padding: 15px;\n  margin: 15px;\n  height: 50px;\n  background-color: lightblue;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./apps/animations-demo/src/app/app.component.css
// module id = ./apps/animations-demo/src/app/app.component.css
// module chunks = main